export const providesList = (resultsWithIds, tagType, tagId = 'id') => {
    return resultsWithIds
        ? [
              { type: tagType, id: 'LIST' },
              ...resultsWithIds.map(({ [tagId]: id }) => ({ type: tagType, id })),
          ]
        : [{ type: tagType, id: 'LIST' }]
}
